import {
  FetchEecsCancellationsPayload,
  FetchEecsFeesPayload,
  FetchEecsTransactionPayload,
  FetchForwardsPayload,
  FetchGoCertificatePayload,
  FetchPackagesPayload,
  FetchProductionDevicesPayload,
} from 'modules/eecs-go';
import { FetchWalletTransactionsPayload } from 'modules/wallet';

export enum EAppDataExportModals {
  EXPORT = 'export',
}

export enum EAppDataExportPages {
  SPOT = 'spot',
  FORWARDS = 'forwards',
  PACKAGES = 'packages',
  TRANSACTIONS = 'transactions',
  PRODUCTION_DEVICES = 'production_devices',
  CANCELLATIONS = 'cancellations',
  WALLET = 'wallet',
  FEES = 'fees',
}

export enum EAppDataExportFileTypes {
  PDF = 'pdf',
  XLS = 'xlsx',
}

export interface IAppDataExportModalPayload {
  page: EAppDataExportPages;
}

export interface IAppDataExportModal {
  type: EAppDataExportModals;
  payload: IAppDataExportModalPayload;
}

export interface IAppDataExportPortfolioPayload extends FetchGoCertificatePayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportForwardsPayload extends FetchForwardsPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportPackagesPayload extends FetchPackagesPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportTransactionsPayload extends FetchEecsTransactionPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportProductionDevicesPayload extends FetchProductionDevicesPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportCancellationsPayload extends FetchEecsCancellationsPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportWalletTransactionsPayload extends FetchWalletTransactionsPayload {
  file_type: EAppDataExportFileTypes;
}

export interface IAppDataExportFeesPayload extends FetchEecsFeesPayload {
  file_type: EAppDataExportFileTypes;
}
